/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Address } from './Address';
export type CreateClientWithoutAccountPayload = {
    gender: CreateClientWithoutAccountPayload.gender;
    firstName: string;
    lastName: string;
    email?: string;
    phoneNumber?: string;
    address?: Address;
    customFieldValues?: Record<string, string>;
};
export namespace CreateClientWithoutAccountPayload {
    export enum gender {
        MALE = 'male',
        FEMALE = 'female',
        DIVERSE = 'diverse',
        NOT_SET = 'not_set',
        DELETED = 'deleted',
    }
}

